import "./DomainMigrationNotice.css";

// 'AAAA-MM-DD' → 'DD/MM/AAAA' (é uma data, não um instante: sem fuso)
const fmtDay = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

const joinHosts = (list) => {
    const names = list.map((d) => d.hostname);
    return names.length > 1 ? `${names.slice(0, -1).join(", ")} e ${names[names.length - 1]}` : names[0];
};

/**
 * O que avisar: domínios da Spectrum com data de expiração (`expiring`) e os
 * da Spectrum que seguem valendo (`keep`, sugestão de migração). null = nada.
 * A mensagem sai dos dados — o admin define a expiração no painel.
 */
export function migrationInfo(domains) {
    const spectrum = (domains || []).filter((d) => d.kind === "spectrum");
    const expiring = spectrum.filter((d) => d.expires_at);
    if (!expiring.length) return null;
    return { expiring, keep: spectrum.filter((d) => !d.expires_at) };
}

function messageOf({ expiring, keep }) {
    const action = keep.length
        ? `atualize seus links: migre para ${joinHosts(keep)} ou use seu próprio domínio.`
        : "use seu próprio domínio para continuar com os links funcionando.";
    return expiring.map((d) => `${d.hostname} expira em ${fmtDay(d.expires_at)}`).join(" · ") + ` — ${action}`;
}

/**
 * Faixa de notícia no topo dos Redirecionadores: amarela, fina, de borda a
 * borda da área de conteúdo, texto fixo.
 */
export default function DomainMigrationNotice({ domains, className = "" }) {
    const info = migrationInfo(domains);
    if (!info) return null;
    return (
        <div role="status" aria-label="Aviso" className={`news-ticker ${className}`}>
            {messageOf(info)}
        </div>
    );
}

export { fmtDay };
